module.exports = __webpack_public_path__ + "img/bust.9e3c8c67.png";